import HomeComponent from '../components/home/home'

const Home = () => {
  return <HomeComponent />
}

export default Home
